import storage from 'viralstyle-ui/src/storage';
import find from 'lodash/find';
import each from 'lodash/each'
import remove from 'lodash/remove';
import { PaginatableCollection } from 'domains/base/store/collections';
import { RecentlyViewedModel } from './models';

const RECENT_KEY = 'recent-campaigns';

export const state = {
  campaigns: new PaginatableCollection(),
  maxPages: null,
  recentCampaigns: storage.get(RECENT_KEY) || [],
};

export const mutations = {
  addRecentlyViewedCampaign(state, campaign) {
    let recentlyViewedCampaign = new RecentlyViewedModel(campaign),
      alreadyViewedCampaign = find(state.recentCampaigns, campaign => campaign.uri === recentlyViewedCampaign.uri);

    if (alreadyViewedCampaign) {
      remove(state.recentCampaigns, alreadyViewedCampaign);

      state.recentCampaigns.unshift(recentlyViewedCampaign);
    } else {
      state.recentCampaigns.unshift(recentlyViewedCampaign);

      state.recentCampaigns.slice(0, 4);
    }

    storage.set(RECENT_KEY, state.recentCampaigns);
  },

  removeRecentlyViewedCampaign(state, campaign) {
    let recentlyViewedCampaign = new RecentlyViewedModel(campaign);

    if (find(state.recentCampaigns, campaign => campaign.uri === recentlyViewedCampaign.uri)) {
      remove(state.recentCampaigns, campaign => campaign.uri === recentlyViewedCampaign.uri);

      storage.set(RECENT_KEY, state.recentCampaigns);
    }
  },

  removeRecentlyViewedCampaignError(state, { publicName, slug, domain }) {
    if (find(state.recentCampaigns, campaign => campaign.uri.indexOf(`${domain}/${slug}`) !== -1)) {
      remove(state.recentCampaigns, campaign => campaign.uri.indexOf(`${domain}/${slug}`) !== -1);

      storage.set(RECENT_KEY, state.recentCampaigns);
    }
  },
};